export const JOB_LABELS = {
    levels: {
        brd: 'Board Member',
        chf: 'C-level Executive',
        vp: 'Vice President',
        dir: 'Director',
        mgr: 'Manager',
        stf: 'Key Influencer'/* ,
        other: 'Other' */
    },
    levels_plural: {
        brd: 'Board Members',
        chf: 'C-level Executives',
        vp: 'Vice Presidents',
        dir: 'Directors',
        mgr: 'Managers',
        stf: 'Key Influencers'/* ,
        other: 'Other' */
    },
    departments: {
        fnad: 'Finance',
        hr: 'HR',
        it_is: 'IT',
        lgl: 'Legal',
        mrkt: 'Marketing',
        ops: 'Operations',
        prc: 'Procurement',
        enrd: 'R&D',
        sale: 'Sales',
        other: 'Cross Functional'
    }
};

export const JOB_LABELS_DEPARTMENTS_ABBREVIATIONS: Record<keyof typeof JOB_LABELS.departments, string> = {
    fnad: 'Fin',
    hr: 'HR',
    it_is: 'IT',
    lgl: 'Lgl',
    mrkt: 'Mktg',
    ops: 'Ops',
    prc: 'Prc',
    enrd: 'R&D',
    sale: 'Sale',
    other: 'Xfct'
};
